import { render, staticRenderFns } from "./offlineCollectionList.vue?vue&type=template&id=51a2eee2&scoped=true"
import script from "./offlineCollectionList.vue?vue&type=script&lang=js"
export * from "./offlineCollectionList.vue?vue&type=script&lang=js"
import style0 from "./offlineCollectionList.vue?vue&type=style&index=0&id=51a2eee2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a2eee2",
  null
  
)

export default component.exports